

import Vue from 'vue'
import Router from 'vue-router'

//Homepage
import App from '../App.vue'

//Alert
import AlertFromTop10 from '../components/functionality/AlertFromTop10.vue'

//ASN Admin
import prefixSettings from '../components/settings/AddPrefix.vue'
import asnSettings from '../components/settings/ASNAllSettings.vue'
import asGroups from '../components/settings/ASGroups.vue'
import alertRules from '../components/settings/AlertRules.vue'

//User Admin
import orgAdmin from '../shared/developing/user-admin.vue'
import userAdmin from '../components/settings/UserSettings.vue'

//Additional Components
import statistics from '../components/functionality/Statistics.vue'
import disaggregation from '../components/functionality/Disag.vue'
import searchEvents from '../components/functionality/SearchEvents.vue'
import prefixRouting from '../components/functionality/PrefixRouting.vue'
import ASNBaseline from '../components/functionality/ASNBaseline.vue'
import country_asn from '../components/functionality/CountryASN.vue'
import asn_owners from '../components/functionality/ASNOwners.vue'
import requestdata from '../components/functionality/RDD.vue'
import topASNs from '../components/functionality/TopASNs.vue'

// Split alerts, user and org
import splitAlertsOrg from '../components/functionality/SplitAlertsOrg.vue'
import splitAlertsUser from '../components/functionality/SplitAlertsUser.vue'

//Changelog
import changelog from '../components/functionality/Changelog.vue'

//Executive Summary
import execsummary from '../components/functionality/ExecSummary.vue'

//Privacy Notice
import privacynotice from '../shared/operational/privacy-notice.vue'

//FAQ
import faq from '../components/functionality/FAQ.vue'

//Analytics
import analytics from '../components/functionality/Analytics.vue'

//Polling API
import pollapi from '../components/functionality/API.vue'

//Dummy Data
import dummydata from '../components/functionality/DummyData.vue'

import test from '../components/functionality/test.vue'

Vue.use(Router);

export default new Router({
  routes: [
    //Homepage
    { path: '/', name: 'App', component: App }, 
    //Alerting Info
    { path: '/alertFromTop10/:prefix', name: 'Alert From Top 10', component: AlertFromTop10 },
    //ASN Admin
    { path: '/prefixSettings', name: 'Restricted Prefix Settings', component: prefixSettings },
    { path: '/asnSettings', name: 'ASN Settings', component: asnSettings },
    { path: '/alertRefinement', name: 'Alert Refinement', component: asGroups },
    { path: '/AlertRules', name: 'Alert Rules', component: alertRules },
    //User Admin
    { path: '/orgAdmin', name: 'Organisation Admin', component: orgAdmin }, 
    { path : '/userAdmin', name: 'User Admin', component: userAdmin},
    //Additional Components
    { path: '/disaggregation', name: 'Disaggregation', component: disaggregation }, 
    { path: '/searchEvents', name: 'Search Events, Episodes or Notifications', component: searchEvents },
    { path: '/statistics', name: 'System Statistics', component: statistics }, 
    { path: '/prefixRouting', name: 'Prefix Routing', component: prefixRouting },
    { path: '/ASNBaseline', name: 'ASN Baseline View', component: ASNBaseline},
    { path: '/countryASN', name: 'Country ASNs', component: country_asn},
    { path: '/asnOwners', name: 'ASN Owners', component: asn_owners},
    { path: '/rawData', name: 'Request Raw Data', component: requestdata},
    { path: '/topASNs', name: 'Top ASNs', component: topASNs},
    //Changelog
    { path: '/changelog', name: 'Changelog', component: changelog},
    //Exec Summary
    { path: '/execSummary', name: 'Executive Summary', component: execsummary},
    //Priv Notice
    { path: '/privNotice', name: 'Privacy Notice', component: privacynotice},
    // User/ Org alerts
    { path: '/orgAlerts', name: 'Organisation Alerts', component: splitAlertsOrg},
    { path: '/userAlerts', name: 'User Alerts', component: splitAlertsUser},
    //Analytics
    { path: '/analytics', name: 'Analytics', component: analytics},
    //FAQ
    { path: '/faq', name: 'Frequently Asked Questions', component: faq},
    //Poll API
    { path: '/pollAPI', name: 'Polling API', component: pollapi},
    // Dummy Data
    { path: '/dummyData', name: 'Dummy Data Injection', component: dummydata},
    // TEST
    { path: '/test', name: 'Test Page', component: test},
  ]
})